
import PageTitle from "../components/common/pageTitle";
import React, { useState, useEffect, useCallback } from "react";
import { makeStyles, Typography } from "@material-ui/core"
import HomeStyles from '../styles/Home.module.css'
import Banner from "../components/common/banner";
import axios from 'axios';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import api from '../libs/utils/axiosApiInstance'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    margin: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '2rem',
    },
    buttonConfirm: {
        background: '#FDB738',
        fontSize: '1.0rem',
        width: '100%',
        height: '45px',
    },
    buttonUpload: {
        background: '#FBBE66',
        color: '#FFFFFF',
        fontSize: '1.0rem',
        width: '100%',
        height: '54px',
    },

}));

function refreshPage() {
    window.location.reload();
}


export default function Agents(props) {
    const query = new URLSearchParams(props.location.search);
    const history = useHistory();
    const classes = useStyles();
    let [isLoading, setLoading] = useState(false);
    const [agents, setAgents] = useState([]);
    const [totalAgents, setTotalAgents] = useState({
        offset: 0,
        data: [],
        perPage: 5,
        currentPage: 0
    });


    useEffect(() => {

        getProfile();
        getTotalAgents();

    }, []);

    const getProfile = async () => {

        const res = await api.get(`/dashboard/front/agents`);
        const _agents = res.data.result;
        setAgents(_agents);
    }

    const getTotalAgents = async () => {

        const res = await api.get(`/dashboard/front/agent-count`);
        const total = res.data.result;
        setTotalAgents(total.AgentCount);
        console.log(totalAgents)
    }

    const linkGoogleMap = () => {

    }


    return (
        <>




            <Banner>
                <div className="container">
                    <PageTitle title="" header="รายการตัวแทนจำหน่าย" />
                    {/* <Breadcrumbs /> */}



                    <div className="row w-100">
                        <div className="col-md-12" >
                            <div className={HomeStyles.card} >
                                <div className="row">
                                <Typography variant="h5" className={classes.title} style={{
                                            marginBottom: '30px',

                                        }}>
                                            ข้อมูลตัวแทนจำหน่าย
                                        </Typography>
                                    <div className="col-lg-12 col-md-12" style={{
                                        height: '90vh',
                                        overflow: 'auto',
                                        position: 'relative'
                                    }}>

                                      
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr style={{
                                                    background: '#4472c4',
                                                    color: 'white',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 10
                                                }}>
                                                    <th scope="col" className="text-center">ที่</th>
                                                    <th scope="col" className="text-center">ชื่อร้าน</th>
                                                    <th scope="col" className="text-center">ที่อยู่</th>
                                                    <th scope="col" className="text-center">เบอร์โทร</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {agents.map((agents, index) =>
                                                    <tr style={{
                                                        background: '#e9ebf5',
                                                        verticalAlign: 'middle'

                                                    }} key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{agents.ContactName}</td>
                                                        <td className="text-center">{agents.ShopHouseNumber} ต.{agents.ShopSubDistrict} อ.{agents.ShopDistrict} จ.{agents.ShopProvince}</td>
                                                        <td className="text-center">{agents.Tel}</td>

                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>






                        </div>
                    </div>

                </div>

            </Banner>










        </>
    )

}

